import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import {fadeIn,wipeOutRight} from '../../app/shared/animation/animation.component';
interface DataItem {
  user_id: number;
  first_name: any;
  role_name: any;
  phone_number: any;
  checked: any
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}

@Component({
  selector: 'user-listing',
  templateUrl: './user-listing.component.html',
  animations:[fadeIn,wipeOutRight]
})
export class UserListingComponent implements OnInit, OnChanges {
  @Input() userData: any[] = [];
  @Output() checkedItemsUser: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() selectedUserIds: any;
  @Input() initiallyCheckedUserIds: number[] = [];

  userDataRaw: any[] = [];
  checkedItems: any[];
  anyChecked: any;
  allChecked: boolean;
  filterVisible: boolean;
  sales: any;
  tech: any;
  searchTerm:string;

  listOfColumns: ColumnItem[] = [
    {
      name: 'Name',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.first_name.localeCompare(b.first_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Role',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.role_name.localeCompare(b.role_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Phone Number',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.phone_number.localeCompare(b.phone_number),
      sortDirections: ['ascend', 'descend', null],
    }
  ];
 
  constructor() {}

  ngOnInit() {
    this.userDataRaw = this.userData
    console.log("this is userDataRaw", this.userDataRaw)
  }

  checkAll(value: boolean): void {
    this.userData.forEach((data) => {
      data.checked = value;
    });
    this.updateCheckedItems();
  }

  onCheckboxChange(): void {
    this.updateCheckedItems();
  }

  private updateCheckedItems(): void {
    this.checkedItems = this.userData
      .filter((element) => element.checked)
      .map((element) => element.user_id);

    this.anyChecked = this.userData.some((e) => e.checked);
    this.allChecked = this.userData.every((e) => e.checked);
    this.checkedItemsUser.emit(this.checkedItems);
  }

  ngOnChanges(changes: SimpleChanges) {}

  onKeyUp(query: string): void {
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.userDataRaw.filter((d) => {
        var found = false;
        if (
          (d.first_name && d.first_name.toLowerCase().includes(q)) ||
          (d.role_name && d.role_name.toLowerCase().includes(q)) ||
          (d.phone_number && d.phone_number.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.userData = searchData;
      this.userData = [...this.userData];
    } else {
      this.userData = [...this.userDataRaw];
    }
  }

  resetSearch(){
    if(this.searchTerm){
      this.searchTerm = '';
      this.userData = [...this.userDataRaw];

    }
  }
  originalSales = false;
  originalTech = false;;

  cancelFilter() {
    this.sales = this.originalSales;
    this.tech = this.originalTech;
    this.filterVisible = false;
  }

  applyFilters() {
    this.originalSales = this.sales;
    this.originalTech = this.tech;
    
    if (this.sales && this.tech) {
        this.userData = this.userDataRaw.filter((user) => user.role_id === 1 || user.role_id === 2);
    } else if (this.sales) {
        this.userData = this.userDataRaw.filter((user) => user.role_id === 1);
    } else if (this.tech) {
        this.userData = this.userDataRaw.filter((user) => user.role_id === 2);
    } else {
        this.userData = this.userDataRaw;
    }
    this.filterVisible = false;
}



  // if (selectedFilters.length <= 0) {
  //   this.addOnData = cloneDeep(this.addOnDataRaw);
  // } else {
  //   let data = this.addOnDataRaw.filter(f => {
  //     let cats = [];
  //     f.Categories.forEach(element => {
  //       cats.push(element.CategoryId);
  //     });
  //     var found = false;
  //     for (let i = 0; i < selectedFilters.length; i++) {
  //       var filter = selectedFilters[i];
  //       cats.forEach(cat => {
  //         if (cat === filter) {
  //           found = true;
  //         }
  //       });
  //     }
  //     return found;
  //   })
  //   this.addOnData = [...data];
  // }

  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      console.log('Popover is now hidden');
      this.cancelFilter()
    } else {
      console.log('Popover is now visible');
    }
  }
}
